import { Link } from "react-router-dom";

/**
 * The page a wrong address lands on.
 *
 * Until now there was no catch-all route, so any URL that matched none of the
 * 160-odd lesson routes rendered an empty <Routes> — a blank white page with
 * no error, nothing in the console, and no way for a student to tell the
 * difference between "wrong link" and "the school's site is broken". One did
 * exactly that on an old /learn/ address and reported the course as empty.
 *
 * A wrong turn should cost a student five seconds, not a support message.
 */
export function NotFound() {
  return (
    <main className="mx-auto flex min-h-[70vh] max-w-2xl flex-col justify-center px-6 py-16">
      <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-nsm-dim">
        Page not found
      </p>
      <h1 className="mt-3 font-display text-3xl font-bold text-nsm-ink">
        That link doesn&rsquo;t point at a lesson.
      </h1>
      <p className="mt-3 text-[15px] leading-relaxed text-nsm-dim">
        The address may have changed, or it may have a typo. Nothing is missing
        from your course — every lesson you have access to is still there.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          to="/course/sight-reading"
          className="rounded-lg bg-nsm-ink px-4 py-2 text-[13px] font-semibold text-nsm-bg transition hover:opacity-90"
        >
          Sight Reading course
        </Link>
        <Link
          to="/"
          className="rounded-lg border border-nsm-border px-4 py-2 text-[13px] font-semibold text-nsm-ink transition hover:bg-nsm-surface"
        >
          All lessons
        </Link>
      </div>
      <p className="mt-8 text-[13px] text-nsm-dim">
        Still stuck? WhatsApp us on{" "}
        <a href="https://wa.me/917760456847" className="font-semibold text-nsm-ink hover:underline">
          +91 77604 56847
        </a>{" "}
        and we&rsquo;ll send you the right link.
      </p>
    </main>
  );
}
